/**
 * File: index.js
 * Project: Aitea-Building
 * File Created: Friday, 25th October 2024 11:14:13 am
 * Author: Daniel Rodríguez Cabrera (daniel.rodriguez@aerin.es)
 * Version: 2.0.0
 * -----
 * Last Modified: Friday, 25th October 2024 11:17:14 am
 * Modified By: Daniel Rodríguez Cabrera
 * -----
 * Copyright (c) 2023 - 2024 Aerin Sistemas S. L. copying, distribution or modification not authorised in writing is prohibited.
 */
import enLang from './entries/en-US';
import esLang from './entries/es-ES';
import caLang from './entries/ca-ES';
import frLang from './entries/fr-FR';
import itLang from './entries/it-IT';

const AppLocale = {
  en: enLang,
  es: esLang,
  ca: caLang,
  fr: frLang,
  it: itLang,
};

export default AppLocale;
